/**
 * Droit d'accès d'un écran ou d'une file du back-office.
 *
 * Il doit refléter le middleware de l'API qui sert l'écran : une entrée
 * visible mais gardée plus étroitement côté API mène l'utilisateur sur un 403,
 * et un 403 hors liste blanche l'éjecte du back-office (voir `axios-client.ts`).
 *
 * - `crm:any`       : super admin, ou accès CRM prospects ou clients ;
 * - `crm:prospects` : super admin, ou accès CRM prospects ;
 * - `crm:clients`   : super admin, ou accès CRM clients ;
 * - `super_admin`   : super admin seulement.
 */
export type StaffAccess = 'crm:any' | 'crm:prospects' | 'crm:clients' | 'super_admin';

interface StaffUser {
    is_super_admin?: boolean;
    can_access_crm_prospects?: boolean;
    can_access_crm_clients?: boolean;
}

export function canAccess(user: StaffUser | null | undefined, access: StaffAccess): boolean {
    if (!user) return false;
    if (user.is_super_admin) return true;

    switch (access) {
        case 'crm:any':
            return Boolean(user.can_access_crm_prospects || user.can_access_crm_clients);
        case 'crm:prospects':
            return Boolean(user.can_access_crm_prospects);
        case 'crm:clients':
            return Boolean(user.can_access_crm_clients);
        case 'super_admin':
            return false;
    }
}

/** Valeur attendue dans `routePermissions` pour un droit donné. */
export function routePermissionFor(access: StaffAccess): string | null {
    return access === 'super_admin' ? null : `_${access}`;
}
